import axios from "axios";

export function getVideoCategoryList(co) {
  const config = {
    params: co,
  };
  return axios.get(
    process.env.VUE_APP_API_URL + "VideoCategory/getlist",
    config
  );
}

export function postVideoCategory(data) {
  const config = {
    headers: { "Content-Type": "multipart/form-data" },
  };
  return axios.post(
    process.env.VUE_APP_API_URL + "VideoCategory/add",
    data,
    config
  );
}

export function updateVideoCategory(data) {
  return axios.put(process.env.VUE_APP_API_URL + "VideoCategory/update", data);
}

export function deleteVideoCategory(videoId) {
  const config = {
    params: {
      videoId: videoId,
    },
  };

  return axios.delete(
    process.env.VUE_APP_API_URL + "VideoCategory/deleted",
    config
  );
}
